import { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getFromLocalStorage,
  setToLocalStorage,
  removeFromLocalStorage,
  clearLocalStorage,
} from "../../lib/localStorage";
const GuiContext = createContext();

export function GuiContextProvider({ children }) {
  const navigate = useNavigate();
  // Podrazumevano PRAZAN objekat, ne oblik sa praznim poljima.
  //
  // `PrivateRoute` prijavljenost prepoznaje po `userData.accounts`, a prazan niz
  // je u JavaScript-u TAČAN — pa je odjavljen korisnik sa oblikom
  // `{accounts: []}` prolazio kroz čuvara i vraćao se na stranicu za prijavljene.
  // Odjava jeste obrisala `localStorage`; lagao je podrazumevani oblik.
  //
  // Ovde nam oblik i ne treba: polja se čitaju sa `?.` i `|| ""`, pa `{}` prolazi
  // isto. Zaštita od nepotpunog zapisa ostaje tamo gde je stvarno potrebna —
  // kod `selected`, gde je jedno polje umelo da nestane.
  const initialState = getFromLocalStorage("userData", {});
  // Podrazumevana vrednost se primenjuje PO POLJU — vidi `getFromLocalStorage`.
  // Zapis kome fali `selectedAccount` je nastajao lako i prolazio je kao
  // ispravan, pa je izbor ostajao prazan i posle osvežavanja stranice.
  const stored = getFromLocalStorage("selected", {
    selectedServer: "",
    selectedAccount: "",
  });
  const selectedInitalState = {
    selectedServer: stored.selectedServer || initialState.servers?.[0] || "",
    selectedAccount: stored.selectedAccount || initialState.accounts?.[0] || "",
  };

  const [userData, setUserData] = useState(initialState);
  const [selected, setSelected] = useState(selectedInitalState);
  // `null` je ovde smislena vrednost („nema izabrane kompozicije"), pa se ne
  // spaja ni sa čim; pomoćnik se koristi zbog iskvarenog zapisa, koji je ovde
  // bacao iz tela providera — dakle bela stranica bez poruke.
  const initialCompositionState = getFromLocalStorage("compositionsContext", null);
  const [compositionsContext, setCompositonsContext] = useState(
    initialCompositionState
  );

  const selectedAccount = (account) => {
    setCompositonsContext(null);
    const newSelected = { ...selected, selectedAccount: account };
    setSelected(newSelected);
    setToLocalStorage("selected", newSelected);
  };
  const selectedServer = (server) => {
    setCompositonsContext(null);
    const newSelected = { ...selected, selectedServer: server };
    setSelected(newSelected);
    setToLocalStorage("selected", newSelected);
  };

  const changeUserData = (data) => {
    setToLocalStorage("userData", data);
    setUserData(data);
    // Isto `|| ""` kao i na ostalim mestima: prijava korisnika sa praznim
    // spiskom baza bi inače upisala `undefined`, koje `JSON.stringify` izbacuje
    // — pa bi izbor ostao nepostojeći do sledećeg ručnog biranja.
    const initialSelected = {
      selectedServer: data.servers?.[0] || "",
      selectedAccount: data.accounts?.[0] || "",
    };
    setSelected(initialSelected);
    setToLocalStorage("selected", initialSelected);
  };
  const updateVersion = (newVersion) => {
    setUserData((prev) => ({ ...prev, version: newVersion }));
    setToLocalStorage("userData", { ...userData, version: newVersion });
  };
  const linkDatabase = (newAccount) => {
    const newAccounts = [...(userData.accounts || []), newAccount];
    const newUserData = { ...userData, accounts: newAccounts };
    setToLocalStorage("userData", newUserData);
    setUserData(newUserData);
    // Prva baza u praznom spisku se i BIRA. Bez ovoga se posle uvoza dobija
    // spisak sa jednom stavkom a bez izbora, pa svi ekrani koji traže ime baze
    // dobiju `undefined` — što izgleda kao da se GUI zaledio.
    if (!selected.selectedAccount) selectedAccount(newAccount);
  };
  const unlinkDatabase = (accountToRemove) => {
    const filteredAccounts = (userData.accounts || []).filter(
      (account) => account !== accountToRemove
    );
    // `|| ""`, nikako `undefined`: `JSON.stringify` izbacuje polja sa
    // `undefined`, pa bi u `localStorage` ostao objekat BEZ `selectedAccount`.
    // Podrazumevana vrednost se pri učitavanju tada ne primenjuje — grana `||`
    // gleda ceo objekat, a on postoji — i izbor ostaje prazan i posle
    // osvežavanja stranice.
    selectedAccount(filteredAccounts[0] || "");
    const newUserData = { ...userData, accounts: filteredAccounts };
    setToLocalStorage("userData", newUserData);
    setUserData(newUserData);
  };
  const updateServers = (newServer) => {
    const newServers = [...userData.servers, newServer];
    const newUserData = { ...userData, servers: newServers };
    setToLocalStorage("userData", newUserData);
    setUserData(newUserData);
  };
  const removeServer = (serverToRemove) => {
    const filteredServers = userData.servers.filter(
      (server) => server !== serverToRemove
    );
    selectedServer(filteredServers[0]);
    const newUserData = { ...userData, servers: filteredServers };
    setToLocalStorage("userData", newUserData);
    setUserData(newUserData);
  };

  const removeTable = (tableToRemove) => {
    try {
      const filteredTables = compositionsContext.compositions.filter(
        (composition) => composition !== tableToRemove
      );
      const newContextData = {
        ...compositionsContext,
        compositions: filteredTables,
      };
      setToLocalStorage("compositionsContext", [newContextData]);
      setCompositonsContext(newContextData);
    } catch (error) {
      console.error(error);
    }
  };
  const logOut = async () => {
    // Sesijski kolačić je httpOnly — JS ga ne može obrisati, samo server. Zato
    // se odjava PRVO javlja backendu da ga poništi; tek onda se čisti lokalno.
    // Ako poziv padne (mreža/server), lokalno stanje se svejedno briše — bolje
    // izgubiti sesiju u pregledaču nego je zaglaviti prijavljenu.
    try {
      const url = process.env.REACT_APP_API_URL || window.location.origin;
      await fetch(`${url}/api/inerygui/logout`, {
        method: "POST",
        credentials: "include",
      });
    } catch (error) {
      // namerno progutano — vidi gore
    }
    setUserData({});
    setCompositonsContext(null);
    clearLocalStorage();
    // removeFromLocalStorage("userData");
    // removeFromLocalStorage("selected");
    // removeFromLocalStorage("compositionsContext");
    // removeFromLocalStorage("tableStructure");
    // removeFromLocalStorage("activeComposition");
    // removeFromLocalStorage("activePlugins");
    // removeFromLocalStorage("pKey");
    navigate("/login");
    window.location.reload();
  };
  const handleComposition = (e) => {
    if (!e) return;
    setCompositonsContext(e);
    setToLocalStorage("compositionsContext", e);
  };
  const resetCompositions = () => {
    setCompositonsContext({});
    removeFromLocalStorage("compositionsContext");
  };
  const valueToShare = {
    //ovo radi ovako kada se podigne build na serveru
    URL: process.env.REACT_APP_API_URL || window.location.origin,
    changeUserData: changeUserData,
    linkDatabase,
    unlinkDatabase,
    updateServers: updateServers,
    removeServer: removeServer,
    logOut: logOut,
    userData: userData,
    selected: selected,
    removeTable: removeTable,
    selectedAccount: selectedAccount,
    selectedServer: selectedServer,
    handleComposition: handleComposition,
    updateVersion: updateVersion,
    compositionsContext: compositionsContext,
    resetCompositions: resetCompositions,
  };

  return (
    <GuiContext.Provider value={valueToShare}>{children}</GuiContext.Provider>
  );
}

export default GuiContext;
